import { getObjectsSum } from '../../../utils/common'
import { formatBirdviewNumber } from '../DashboardBirdview.utils.charts'

import { BIRDVIEW_AGING_CHART_X_AXIS_PROPS } from './BirdviewAgingChart.constants'

// A bucket also carries the count of itself and every older one ("stuck 30+
// days"); on the oldest bucket that would only repeat its own value.
export function getBirdviewAgingChartItems(items) {
  return items.map((item, index) => ({
    ...item,
    ...(index < items.length - 1
      ? { cumulative: getObjectsSum(items.slice(index)) }
      : null),
  }))
}

export function getBirdviewAgingChartLegendItems(items) {
  return items.map(({ color, id, label }) => ({ color, id, label }))
}

// The axis shows the counts; the bucket names live in the legend. A count is
// found by its bucket label: recharts numbers only the ticks it draws.
export function getBirdviewAgingChartXAxisProps(items) {
  const values = Object.fromEntries(
    items.map(({ label, value }) => [label, value])
  )

  return {
    ...BIRDVIEW_AGING_CHART_X_AXIS_PROPS,
    tickFormatter: label => formatBirdviewNumber(values[label]),
  }
}
